/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartplaceholdersentence4Inputs */

const en_eventaistartplaceholdersentence4 = /** @type {(inputs: Eventaistartplaceholdersentence4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazz brunch on Sunday from 10, 24 euros`)
};

const de_eventaistartplaceholdersentence4 = /** @type {(inputs: Eventaistartplaceholdersentence4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazzfrühstück am Sonntag ab 10 Uhr, 24 Euro`)
};

/**
* | output |
* | --- |
* | "Jazz brunch on Sunday from 10, 24 euros" |
*
* @param {Eventaistartplaceholdersentence4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartplaceholdersentence4 = /** @type {((inputs?: Eventaistartplaceholdersentence4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartplaceholdersentence4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartplaceholdersentence4(inputs)
	return de_eventaistartplaceholdersentence4(inputs)
});
export { eventaistartplaceholdersentence4 as "eventAiStartPlaceholderSentence" }